var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab_menu",class:{'purchase': _vm.isPurchase}},_vm._l((_vm.tabs),function(tab){return _c('div',{key:tab.id,staticClass:"tab",class:{ active: _vm.activeTab === tab.id ,'purchase': _vm.isPurchase},on:{"click":function($event){return _vm.changeTab(tab)}}},[_vm._v(" "+_vm._s(_vm.t(tab.label))+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }